import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {GestionIntegracionesResumenComponent} from "./gestion-integraciones-resumen.component";
import {TarjetaResumenDatosModule} from "../tarjeta-resumen-datos/tarjeta-resumen-datos.module";

@NgModule({
  declarations: [
    GestionIntegracionesResumenComponent
  ],
  exports: [
    GestionIntegracionesResumenComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TarjetaResumenDatosModule,
  ]
})
export class GestionIntegracionesResumenModule {
}
